import { z } from 'zod/v4';
// export interface paginationPrepare {
//   page?: number;
//   size?: number;
//   search?: string;
//   filter?: filter[] | string;
//   sort?: [sort] | string;
// }

export const OperatorDTO = z.union([
  z.literal('is_null'),
  z.literal('is_not_null'),
  z.literal('is'),
  z.literal('is_not'),
  z.literal('=='),
  z.literal('eq'),
  z.literal('!='),
  z.literal('ne'),
  z.literal('>'),
  z.literal('gt'),
  z.literal('<'),
  z.literal('lt'),
  z.literal('ge'),
  z.literal('>='),
  z.literal('le'),
  z.literal('like'),
  z.literal('ilike'),
  z.literal('in'),
  z.literal('contains'),
  z.literal('not_in'),
  z.literal('between'),
]);
export type Operator = z.infer<typeof OperatorDTO>;
// Generic Page DTO with default unknown
export const PageDTO = z.object({
  items: z.array(z.unknown()),
  total: z.number(),
  page: z.number(),
  size: z.number(),
  allow_fields: z.array(z.string()),
  allow_tags: z.array(z.string()).optional(),
});

export type Page<T = unknown> = Omit<z.infer<typeof PageDTO>, 'items'> & {
  items: T[];
};

export interface PaginationFilter<T extends any = string> {
  field: string;
  op: Operator;
  value: T;
  condition: 'or' | 'and';
}
export interface PaginationSort {
  field: string;
  direction: 'asc' | 'desc';
}
export interface PaginationParamsRaw {
  filter?: string | PaginationFilter[];
  sort?: string | PaginationSort[];
  tags_filter?: string | string[];
  page?: number;
  size?: number;
  [key: string]: any;
}

export enum SORT_DIR {
  ASC = 'asc',
  DESC = 'desc',
}
export interface PaginationParams
  extends Omit<PaginationParamsRaw, 'filter' | 'sort' | 'tags_filter'> {
  filter?: string;
  sort?: string;
  tags_filter?: string;
  size?: number;
  [key: string]: any;
}
export const DEFAULT_PAGE_SIZE = 100;

export const serializePaginationParams = <T extends PaginationParamsRaw>(
  params: T,
): Omit<T, 'filter' | 'sort' | 'tags_filter'> & PaginationParams => {
  const paramsWithDefaults = {
    ...params,
    size: params.size ?? DEFAULT_PAGE_SIZE,
  };
  const { filter, sort, tags_filter } = paramsWithDefaults;

  const result = {
    ...paramsWithDefaults,
    tags_filter:
      typeof tags_filter === 'string'
        ? tags_filter
        : JSON.stringify(tags_filter),
    filter: typeof filter === 'string' ? filter : JSON.stringify(filter),
  } as Omit<T, 'filter' | 'sort' | 'tags_filter'> & PaginationParams;

  if (sort !== null) {
    result.sort = typeof sort === 'string' ? sort : JSON.stringify(sort);
  }

  return result;
};

export interface DatePage<T> extends Page<T> {
  start_datetime: number;
  last_viewed_at: number;
  to_datetime: number;
  window: number;
}